/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

const selectError = (state) => state.get('growler');

const selectErrorText = () => createSelector(
  selectError,
  (globalState) => globalState.get('text')
);
const selectErrorStatus = () => createSelector(
  selectError,
  (globalState) => globalState.get('status')
);
const selectAction = () => createSelector(
  selectError,
  (globalState) => globalState.get('action')
);

export {
  selectAction,
  selectErrorText,
  selectErrorStatus,
};



// WEBPACK FOOTER //
// ./src/containers/Notification/selectors.js